module.exports = __webpack_public_path__ + "vue/img/icon-b-01.f0c6141f.png";